import { npiValidator } from "./npi";

/**
 * Creates an NPI validator for antd Form.Item
 * @param {string} requiredMessage - Error message when NPI is empty
 * @param {string} formatMessage - Error message when NPI format is invalid
 * @returns {Function} Validator function for antd Form.Item rules
 */
export const createNpiValidator = (requiredMessage, formatMessage) => (_, value) => {
  if (!value) {
    return Promise.reject(new Error(requiredMessage));
  }
  if (!npiValidator(value)) {
    return Promise.reject(new Error(formatMessage));
  }
  return Promise.resolve();
};

/**
 * Creates an email validator for antd Form.Item
 * @param {string} invalidMessage - Error message when email format is invalid
 * @returns {Function} Validator function for antd Form.Item rules
 */
export const createEmailValidator = (invalidMessage) => (_, value) => {
  if (!value) {
    return Promise.resolve(); // Email is optional
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(value)) {
    return Promise.reject(new Error(invalidMessage));
  }
  return Promise.resolve();
};
